import {
  OPEN_AI_CHAT,
  CLOSE_AI_CHAT,
  TOGGLE_AI_CHAT,
  OPEN_AI_CHAT_WITH_CONTEXT,
  CLEAR_AI_CHAT_CONTEXT,
  SET_AI_CHAT_PREDEFINED_PROMPT,
  CLEAR_AI_CHAT_PREDEFINED_PROMPT,
  OPEN_AI_CHAT_WITH_HELP_CENTER_URL,
  CLEAR_AI_CHAT_HELP_CENTER_URL,
  AIChatActionTypes,
  WsMemberSelectedContext,
} from "./aiChatTypes";

export interface AIChatPredefinedPrompt {
  chatInput: string;
  predefinedPrompt: string;
}

export interface AIChatReducerState {
  isAIChatOpen: boolean;
  wsMemberSelectedContext: WsMemberSelectedContext | null;
  predefinedPrompt: AIChatPredefinedPrompt | null;
  helpCenterUrl: string | null;
}

const initialState: AIChatReducerState = {
  isAIChatOpen: false,
  wsMemberSelectedContext: null,
  predefinedPrompt: null,
  helpCenterUrl: null,
};

export default function aiChatReducer(
  state = initialState,
  action: AIChatActionTypes,
): AIChatReducerState {
  switch (action.type) {
    case OPEN_AI_CHAT:
      return {
        ...state,
        isAIChatOpen: true,
        helpCenterUrl: null,
      };

    case CLOSE_AI_CHAT:
      return {
        ...state,
        isAIChatOpen: false,
      };

    case TOGGLE_AI_CHAT:
      return {
        ...state,
        isAIChatOpen: !state.isAIChatOpen,
        helpCenterUrl: state.isAIChatOpen ? state.helpCenterUrl : null,
      };

    case OPEN_AI_CHAT_WITH_CONTEXT:
      return {
        ...state,
        isAIChatOpen: true,
        wsMemberSelectedContext: action.payload.wsMemberSelectedContext,
        helpCenterUrl: null,
      };

    case CLEAR_AI_CHAT_CONTEXT:
      return {
        ...state,
        wsMemberSelectedContext: null,
      };

    case SET_AI_CHAT_PREDEFINED_PROMPT:
      return {
        ...state,
        predefinedPrompt: {
          chatInput: action.payload.chatInput,
          predefinedPrompt: action.payload.predefinedPrompt,
        },
        helpCenterUrl: null,
      };

    case CLEAR_AI_CHAT_PREDEFINED_PROMPT:
      return {
        ...state,
        predefinedPrompt: null,
      };

    case OPEN_AI_CHAT_WITH_HELP_CENTER_URL:
      return {
        ...state,
        isAIChatOpen: true,
        helpCenterUrl: action.payload.helpCenterUrl,
      };

    case CLEAR_AI_CHAT_HELP_CENTER_URL:
      return {
        ...state,
        helpCenterUrl: null,
      };

    default:
      return state;
  }
}
